
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/skireport",
      function () {
        return require("private-next-pages/[region]/[resort]/skireport.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/skireport"])
      });
    }
  